import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'ACTIVITY_FEED';

export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(
    `${domain}/FETCH`,
    childId => ({childId}),
    (days, childId, day, ceilingReached, shouldStopInfiniteScroll) => ({
        days,
        childId,
        day,
        ceilingReached,
        shouldStopInfiniteScroll,
    }),
);

export const {
    action: fetchFuture,
    success: fetchFutureSuccess,
    failed: fetchFutureFailed,
} = createAction(
    `${domain}/FETCH_FUTURE`,
    (childId, day) => ({childId, day}),
    (day, days, ceilingReached, childId) => ({day, days, ceilingReached, childId}),
);

export const {
    action: fetchPast,
    success: fetchPastSuccess,
    failed: fetchPastFailed,
} = createAction(
    `${domain}/FETCH_PAST`,
    (childId, day) => ({childId, day}),
    (day, days, ceilingReached, shouldStopInfiniteScroll, childId) => ({
        day,
        days,
        ceilingReached,
        shouldStopInfiniteScroll,
        childId,
    }),
);

export const {
    action: deleteEvent,
    success: deleteEventSuccess,
    failed: deleteEventFailed,
} = createAction(
    `${domain}/DELETE_EVENT`,
    (event, options) => ({event, options}),
    event => ({event}),
    event => ({event}),
);

export const {
    action: refetchDays,
    success: refetchDaysSuccess,
    failed: refetchDaysFailed,
} = createAction(
    `${domain}/REFETCH_DAYS`,
    (startDate, endDate, childId) => ({startDate, endDate, childId}),
    (days, childId) => ({days, childId}),
    (startDate, endDate) => ({startDate, endDate}),
);

export const {action: reset} = createAction(`${domain}/RESET`);

export const {
    action: checkIn,
    success: checkInSuccess,
    failed: checkInFailed,
} = createAction(`${domain}/CHECK_IN`, (childId, groupId, showWarningOnCheckIn) => ({
    childId,
    groupId,
    showWarningOnCheckIn,
}));

export const {
    action: checkOut,
    success: checkOutSuccess,
    failed: checkOutFailed,
} = createAction(`${domain}/CHECK_OUT`, childId => ({childId}));
